module.exports = __webpack_public_path__ + "static/key-darkfuture-b9d0443a198485dd0db91e5c0c1a3423.webp";